import React from 'react'
import {connect} from 'react-redux'

import {TweenMax,Circ,TimelineMax,Power0,Power3,Power2} from 'gsap'
import SplitText from 'gsap/SplitText'


import ScrollArrow from '../scrollarrow/ScrollArrow'

import MultiLangText from '../multilang/MultiLangText'

import MetaTags from 'react-meta-tags'


class ApproachPage extends React.Component {


  constructor(props){
      super()

      this.state ={
        showScrollArrow:false,
        animation_tl : null
      }

      this.setUpAnimation = this.setUpAnimation.bind(this);
      this.onScroll = this.onScroll.bind(this);
      this.exitAnimation = this.exitAnimation.bind(this)
  }

  onScroll(){

      let windowScrollY = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      let container = this.refs.container.getBoundingClientRect()
      let triggerPoint = windowScrollY+(window.innerHeight / 2) - 200;
      let containerY = container.top+windowScrollY
          //console.log(containerY,container.top,triggerPoint,container,this.refs.container,window.scrollY);

          if(containerY< triggerPoint){
            //console.log('triggerAnimation');
            this.playAnimation();
          }

  }
  playAnimation(){
    this.state.animation_tl.pause();
    this.state.animation_tl.progress(0);
    this.state.animation_tl.play()
    this.setState({animationTriggred:true})
    window.removeEventListener('scroll',this.onScroll)
  }

  setUpAnimation(){

      let animation_tl = new TimelineMax({repeat:0 })

      let header = this.refs.container.querySelector('h2')
      let paras = this.refs.container.querySelectorAll('p')
          //console.log("Approach Paras",paras);



          animation_tl.from(header,1,{alpha:0})

          for(let para of paras){
            animation_tl.fromTo(para,.3,{alpha:1,scaleX:0},{alpha:1,scaleX:1,ease:Power2.easeOut},'-=.15')
              let paraSplit = new SplitText(para, {type:"lines,words,chars"})
              let paraChars = paraSplit.lines; //an array of all the divs that wrap each character
            animation_tl.staggerFrom(paraChars, .8, {opacity:0,ease:Power0.easeNone}, 0.4);
          }

          animation_tl.add(()=>{
            this.setState({showScrollArrow:true})
          })


          animation_tl.pause();

          this.setState({animation_tl})

          //;
          //let line1Split = new SplitText(this.refs.line1, {type:"words,chars"})
          //let line1Chars = line1Split.chars; //an array of all the divs that wrap each character



  }

  exitAnimation(){
    // console.log('exitAnimation');
    //  this.state.animation_tl.timeScale( 8 )
    //  this.state.animation_tl.reverse()

      // find workpage.
      let workSection = document.querySelector('.accordion-page.work');
      let workLink = workSection.querySelector('.accordion-link');

      let transitionOut = new TimelineMax()
      //let delay =   this.state.animation_tl.duration() / 8
          transitionOut.to(window,1,{scrollTo:workSection})
        //  transitionOut.add(()=>{
        //        workLink.click();
        //  })

  }

  componentDidMount(){
    this.setUpAnimation();
    let triggerTimeout = setTimeout(()=>{
      window.addEventListener('scroll',this.onScroll)
    },750);

    this.setState({triggerTimeout})
  }

  componentWillUnmount(){
    this.state.animation_tl.pause();
    this.state.animation_tl.progress(0);
    window.removeEventListener('scroll',this.onScroll)
  }










  render () {

    let approachContent = this.props.pagesData.data.filter((item)=>{
      return (item.slug==='approach')
    })[0]

        return(
            <div className="approach-page full-browser scroll-anchor" ref="container">
              <div className="text">
                <MultiLangText className="text-inner" text={approachContent.acf} />
              </div>

              <div className={"scroll-arrow-container pink-arrow"} ref="scrollArrowContainer">
                {(this.state.showScrollArrow)?
                  <div style={{height:'100%',width:'100%'}}>
                    <ScrollArrow />
                  </div>
                : null }
              </div>

              <MetaTags>
                <meta name="description" content={(approachContent.acf.meta_description)? approachContent.acf.meta_description : ''} />
              </MetaTags>

            </div>
          )

  }
}


const mapStateToProps = (state)=>{
  let pagesData = state.KastnerStore.pagesData

  return {
      pagesData
    }
}

export default connect(mapStateToProps)(ApproachPage);



// WEBPACK FOOTER //
// ./src/modules/pages/ApproachPage.js